import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Chip
} from "@mui/material";

import CloudDoneIcon from "@mui/icons-material/CloudDone";

export default function WelcomeCard() {

    const today = new Date().toLocaleDateString(undefined, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    });

    return (

        <Card
            elevation={2}
            sx={{
                mb: 3,
                borderRadius: 3
            }}
        >

            <CardContent>

                <Typography
                    variant="h4"
                    fontWeight="bold"
                >
                    Welcome back 👋
                </Typography>

                <Typography
                    color="text.secondary"
                    sx={{ mt: 1 }}
                >
                    Administrator
                </Typography>

                <Typography
                    color="text.secondary"
                    sx={{ mt: 1 }}
                >
                    {today}
                </Typography>

                <Box
                    sx={{
                        mt: 3,
                        display: "flex",
                        gap: 2,
                        flexWrap: "wrap"
                    }}
                >

                    <Chip
                        color="success"
                        icon={<CloudDoneIcon />}
                        label="Google Drive Connected"
                    />

                    <Chip
                        color="primary"
                        label="Knowledge Hub Online"
                    />

                </Box>

            </CardContent>

        </Card>

    );

}